const renderDefaultNotifications = {
    shouldRender: (renderProps) => {
        return renderProps.isLoggedIn;
    },
    makeRenderer: (renderProps) => (props) => {
        return renderProps.renderNotifications(props);
    },
};
const renderNothing = {
    shouldRender: (renderProps) => {
        return (!renderProps.isLoggedIn || renderProps.currentUrl.includes('/onboarding'));
    },
    makeRenderer: () => () => {
        return null;
    },
};
const configs = [
    renderNothing,
    renderDefaultNotifications,
];
const findNotificationsRenderer = (renderProps) => {
    const foundConfig = configs.find((config) => {
        return config.shouldRender(renderProps);
    });
    return foundConfig && foundConfig.makeRenderer(renderProps);
};
export default findNotificationsRenderer;
//# sourceMappingURL=findNotificationsRenderer.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
